module.exports = __webpack_public_path__ + "img/google.0b1e5c66.png";